<template>
  <TableCellBase :left="left" :right="right">
    <slot name="before"></slot>
    <NuxtLink class="underline block" :to="{ path }"
      ><slot name="default"></slot
    ></NuxtLink>
  </TableCellBase>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    path: string;
    left?: boolean;
    right?: boolean;
  }>(),
  {
    left: false,
    right: false,
  }
);
</script>
